<template>
  <transition name="modal">
    <div class="modal-dialog modal-sm">
      <div class="modal" style="display: block;background-color:rgba(0,0,0,0.7)">
        <div class="modal-dialog" role="document" :style="{'width':_width+'px'}">
          <div class="modal-content MyPDF">
            <div class="modal-header">
              <slot name="header"></slot>
            </div>

            <div class="modal-body">
              <slot name="body"></slot>
            </div>

            <div class="modal-footer">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return { _width: 600 };
  },
  props: {
    width: Number
  },
  beforeMount() {
    this._width = this.width == null ? 600 : this.width;
  }
};
</script>